import { defineNuxtPlugin } from '#app'
import * as vuetif from '../vuetify.config'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

import 'assets/styles/variables.styl'
import 'assets/styles/global.styl'
import 'assets/styles/font.styl'

export default defineNuxtPlugin((nuxtApp: any) => {
  nuxtApp.vueApp.use(vuetif.vuetify)
})
